/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Filters/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AppointmentStatus from './AppointmentStatus/index'
import AppointmentType from './AppointmentType/index'
import ClearAll from './ClearAll/index'
import Flow from './Flow/index'
import React from 'react'
import Search from './Search/index'
import TreatmentStatus from './TreatmentStatus/index'
import Type from './Type/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Filters({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentAutomations/AutomationsList/Filters"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Filters.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Filters.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-1-Wv2Qg': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<div
  data-testid="Filters.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="Filter by:"
/>
</div>
<Type
  viewPath={`${viewPath}/Type`}
/>
<Flow
  viewPath={`${viewPath}/Flow`}
/>
<AppointmentStatus
  viewPath={`${viewPath}/AppointmentStatus`}
/>
<AppointmentType
  viewPath={`${viewPath}/AppointmentType`}
/>
<TreatmentStatus
  viewPath={`${viewPath}/TreatmentStatus`}
/>
<ClearAll
  viewPath={`${viewPath}/ClearAll`}
/>
</div>
<Search
  viewPath={`${viewPath}/Search`}
/>
</div>
{children}
</React.Fragment>)
}